/* eslint-disable import/prefer-default-export */
import { emptyList } from '@constants/empty';

export const AXIS_STYLE = {
  fontSize: '8px',
  fontWeight: '700',
  lineHeight: '10px',
  color: 'var(--color-text-secondary)',
  overflow: 'visible',
  letterSpacing: '0.02em'
};

export const X_AXIS_STYLE = {
  ...AXIS_STYLE,
  fontSize: '10px'
};

export const getPastEpochList = (startDay, totalDays, incrementBy) => {
  const list = [];
  for (let i = startDay; i < totalDays; i += incrementBy) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    list.push(d.getTime());
  }
  return list;
};

export const getFormatedData = (data = emptyList) => {
  const output = [];
  for (let i = 0; i < data?.length; i += 1) {
    output.push({
      rating: data?.[i]?.rating,
      timeline: data?.[i]?.epoch * 1000
    });
  }
  return output;
};

export const getTextWidth = (text = '') => {
  const font = '600 10px AvertaStd';
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = font;
  const { width } = context.measureText(text);
  return width;
};

export const KEY_TYPE_MAP = {
  competesAttempted: { type: 'TOTAL', pos: 0 },
  competesWon: { type: 'WINS', pos: 1 },
  competesLost: { type: 'LOSSES', pos: 2 },
  competesDrawn: { type: 'DRAWS', pos: 3 }
};
